import { TableHeadersConfig } from '../../utils/utils';

export const productsTableConfig: TableHeadersConfig[] = [
  {
    title: '#',
  },
  {
    title: 'Description',
    sortingKey: 'description',
  },
  {
    title: 'Code',
    sortingKey: 'code',
  },
  {
    title: 'Stock Code',
    sortingKey: 'stockCode',
  },
  {
    title: 'Price',
    sortingKey: 'price',
  },
  {
    title: 'Tax Rate',
    sortingKey: 'taxrate.percentageAmount',
  },
  {
    title: 'Category',
    sortingKey: 'category.description',
  },
  {
    title: 'Unit Of Measure',
    sortingKey: 'unitOfMeasure',
  },
  {
    title: 'Min Selling Quantity',
    sortingKey: 'minSellingAmount',
  },
  {
    title: 'Icon Path',
    sortingKey: 'icon',
  },
  {
    title: 'Barcode',
  },
  {
    title: 'Action',
  },
];



// WEBPACK FOOTER //
// ./src/pages/products/productsTableConfig.ts